module.exports = __webpack_public_path__ + "img/case7.0251b2f7.svg";